import { FieldValues, UseFormRegister, UseFormSetValue } from 'react-hook-form'
import { IAnswer, IAnswerWithValue, ITable } from '@/models'
import { Checkbox, Screen } from '@/components/ui'
import s from './question-types.module.scss'

interface ITableQuestionProps {
  question: ITable
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
}

const TableQuestion = ({ question, register, setValue }: ITableQuestionProps) => (
  <>
    <Screen size='lg'>
      <div className={s['question-table']}>
        <table>
          <thead>
            <tr>
              <td aria-label='td' />
              {question.scale.map((scale: IAnswerWithValue) => (
                <td key={scale.uuid}>{scale.title}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {question.objects.map((object: IAnswer) => (
              <tr key={object.uuid}>
                <td className={s['object-title']}>{object.title}</td>
                {question.scale.map((scale: IAnswerWithValue) => (
                  <td
                    key={scale.uuid}
                    onClick={() => {
                      setValue(`${question.id}.${object.uuid}`, scale.uuid)
                    }}
                  >
                    <Checkbox
                      register={register}
                      name={`${question.id}.${object.uuid}`}
                      type='radio'
                      value={scale.uuid}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Screen>
    <Screen size='lg' down>
      <table className={s['question-table__mobile']}>
        {question.objects.map((object: IAnswer) => (
          <tbody key={object.uuid} className={s['question-block']}>
            <tr className={s['question-title']}>
              <td className={s['object-title']}>{object.title}</td>
            </tr>
            {question.scale.map((scale: IAnswerWithValue) => (
              <tr
                key={scale.uuid}
                onClick={() => {
                  setValue(`${question.id}.${object.uuid}`, scale.uuid)
                }}
              >
                <td className={s['answer-title']}>{scale.title}</td>
                <td key={scale.uuid} className={s['answer-checkbox-wrapper']}>
                  <Checkbox
                    register={register}
                    name={`${question.id}.${object.uuid}`}
                    type='radio'
                    value={scale.uuid}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </Screen>
  </>
)

export default TableQuestion
